export const limitText = (text, limit) => {
  if (!text) return "";
  const textLength = text.length;
  if (textLength > limit) return `${text.slice(0, limit)}...`;
  return text;
};

export const limitTitle = (title, limit) => {
  if (!title) return "";
  const titleLength = title.length;
  if (titleLength > limit) return title;
  return "";
};
